// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__12xIH","rightAdornment":"Header_rightAdornment__ipCzc"};